<div class="auth-sso-container" *ngIf="translationsLoaded">
  <mat-card>
    <main class="auth-sso-p-sm" mat-card-content>
      <h3>{{ 'auth.sso.signInOptions' | t }}</h3>
      <div *ngIf="isLoading">
        {{ 'auth.sso.checkingProviders' | t }}
        <mat-progress-bar mode="indeterminate"></mat-progress-bar>
      </div>
      <div class="option-container" *ngIf="!isLoading">
        <mat-card class="option-card" *ngFor="let option of options">
          <mat-card-content (click)="goToProvider(option)">
            <img *ngIf="option.logo" [src]="sanitizeUrl(option.logo)" />
            <div class="option-card__media-title">
              <span>{{ option.name }}</span>
            </div>
          </mat-card-content>
        </mat-card>
      </div>
    </main>
  </mat-card>
</div>
